import { praktikoInstance } from '@/axios';
/* eslint-disable no-param-reassign */

function searchIconByUrl(urlIcon, iconList) {
	return iconList.find(i => i.urlImage === urlIcon);
}

const iconModule = {
	actions: {
		async create({ dispatch }, body) {
			await praktikoInstance.post('icons', body);
			dispatch('load');
		},
		async load({ commit }) {
			const { data: res } = await praktikoInstance.get('icons');
			commit('SET_ICON_LIST', res);
		},
		selectIconAction({ commit }, icon) {
			commit('SET_SELECTED_ICON', icon);
		},
		async callingIconsAndSelectingIt({ dispatch, state, commit }, urlImage) {
			await dispatch('load');
			const icon = searchIconByUrl(urlImage, state.icon.list);
			commit('SET_SELECTED_ICON', icon);
		},
	},
	getters: {
		iconSelectedId(state) {
			return state.selectedIcon ? state.selectedIcon.id : 0;
		},
		iconSelectedName(state) {
			return state.selectedIcon ? state.selectedIcon.name : '';
		},
		urlIcon(state) {
			return state.selectedIcon ? state.selectedIcon.urlImage : '';
		},
	},
	mutations: {
		SET_ICON_LIST(state, icons) {
			state.icon.list = icons;
		},
		SET_SELECTED_ICON(state, icon) {
			state.selectedIcon = icon;
		},
	},
	state: {
		selectedIcon: null,
		icon: {
			list: [],
		},
	},
};
export default iconModule;



// WEBPACK FOOTER //
// ./src/store/modules/icons/index.js